export default `
  mutation MJresetPassword($id: ID!, $resetPasswordToken: String!, $newPassword: String!) {
    MJresetPassword(id: $id, resetPasswordToken: $resetPasswordToken, newPassword: $newPassword)
  }
`
